import { render } from "./program-import.vue?vue&type=template&id=3c884b11&lang=pug"
import script from "./program-import.vue?vue&type=script&lang=js"
export * from "./program-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__